import { useEffect, useState } from 'react';

/**
 * @param isLoading whether the thing that might time out is loading or not.
 * @param milliseconds the timeout value
 * @returns true if is loading is true for longer than the number of milliseconds passed in,
 * false otherwise, including when isLoading is false.
 */
export function useTimeout(isLoading: boolean, milliseconds: number): boolean {
    const [isTimedOut, setIsTimedOut] = useState(false);

    useEffect(() => {
        let timer: number | undefined;

        if (isLoading) {
            if (!isTimedOut) {
                // start timer if not started yet
                timer = window.setTimeout(() => {
                    setIsTimedOut(true);
                }, milliseconds);
            }
        } else {
            // if loading is false, isTimedOut is always false
            clearTimeout(timer);
            timer = undefined;
            setIsTimedOut(false);
        }

        return () => {
            clearTimeout(timer);
        };
    }, [isLoading, isTimedOut, milliseconds]);

    return isTimedOut;
}
